export default "__VITE_ASSET__CGgHVQXq__"